import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { AbstractWidgetConfig } from "@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget";
import { WidgetConfigPlantingBudgetAndActualResults, WidgetData } from "@/components/Dashboard/Widgets/types/Widget";
import { PlantingDetailResponse } from "@/types/APIResponse";
import SelectPlanting from "@/components/SelectPlanting/SelectPlanting.vue";
import moment from 'moment';

type SelectedPlanting = {
    id: string
    name: string
}

type CallbackPlanting = {
    id: string
    name: string
    crop: {
        id: string
        name: string
    }
    cultivation_plan: {
        work_start: string | null
        work_end: string | null
    }
}

type AmountUnit = {
    label: string
    value: number
}

@Component({
    components: {
        SelectPlanting
    }
})
export default class WidgetConfigPlantingBudgetAndActualResultsPart extends AbstractWidgetConfig<WidgetConfigPlantingBudgetAndActualResults> {
    config: WidgetConfigPlantingBudgetAndActualResults = {
        plantingId: '',
        startDate: '',
        endDate: '',
        unit: {
            label: '円',
            value: 1
        }
    }
    @Prop()
    private value!: boolean
    @Prop()
    public widgetData!: WidgetData;

    private isShowSelectPlanting = false
    private selectedPlanting: SelectedPlanting = {
        id: '',
        name: ''
    }
    private units: AmountUnit[] = [
        {
            label: '円',
            value: 1
        },
        {
            label: '千円',
            value: 1000
        }
    ]

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Emit('updateConfig')
    updateConfig() {
        return this.config
    }

    created(): void {
        this.$root.$emit('header-inert', true);
        this.initConfig()
        this.validate()
    }

    private initConfig() {
        this.selectedPlanting = {
            id: '',
            name: ''
        }
        if (!this.widgetData.config) {
            this.config = {
                plantingId: '',
                startDate: '',
                endDate: '',
                unit: {
                    label: '円',
                    value: 1
                }
            }
        } else {
            this.config = {...this.widgetData.config}
            if (this.widgetData.config.plantingId == "作付未指定") {
                this.selectedPlanting = {
                    id: "作付未指定",
                    name: "作付未指定"
                }
                this.config.plantingId = "作付未指定"
                this.validate()
            } else {
                this.getPlanting(this.config.plantingId)
            }
        }
    }

    @Watch('widgetData')
    whenOpen(): void {
        this.initConfig()
        this.validate()
    }

    private getPlanting(plantingId: string) {
        this.$apiClient.doRequest('get', `/plantings/${plantingId}`).then((res: PlantingDetailResponse) => {
            this.selectedPlanting = {
                id: res.id,
                name: res.name
            }
            this.config.plantingId = res.id
            this.validate()
        })
    }

    private openSelectPlantingModal() {
        this.isShowSelectPlanting = true
    }

    private setPlanting(planting: CallbackPlanting): void {
        this.selectedPlanting = {
            id: planting.id,
            name: planting.name
        }
        this.config.plantingId = planting.id
        if (this.config.plantingId !== "作付未指定") {
            this.config.startDate = ""
            this.config.endDate = ""
        }
        this.validate()
    }

    private closeSelectPlantingModal() {
        this.isShowSelectPlanting = false
    }

    validate(): void {
        let valid = true
        if (!this.config.plantingId) {
            valid = false
        }
        if (this.config.plantingId === '作付未指定') {
            if (!this.config.startDate) {
                valid = false
            }
            if (!this.config.endDate) {
                valid = false
            }
            if (moment(this.config.startDate).isAfter(moment(this.config.endDate))) {
                valid = false
            }
        } else {
            this.config.startDate = ""
            this.config.endDate = ""
        }
        if (!this.config.unit.value) {
            valid = false
        }
        this.input(valid)
        this.updateConfig()
    }
}
